import { useCallback, useEffect, useMemo } from 'react';

import { useDispatch } from 'react-redux';
import { getRecordKeyFor } from '~/reducers/customerCommunicationReducer';

import fetchCustomScheduleHolidayTypes from '~/actions/customerCommunication/fetchCustomScheduleHolidayTypes';

import { useAppSelector } from '../store';

function useCustomScheduleHolidayTypes(brandId: string) {
  const [key, params] = useMemo(() => {
    const params: Parameters<typeof fetchCustomScheduleHolidayTypes> = [brandId];
    return [getRecordKeyFor(...params), params];
  }, [brandId]);

  const dataReq = useAppSelector((state) => state.customerCommunication.customScheduleHolidayTypesRecords[key]);

  const appDispatch = useDispatch();
  const fetchHolidayTypes = useCallback(() => {
    appDispatch(fetchCustomScheduleHolidayTypes(...params));
  }, [appDispatch, params]);

  useEffect(() => {
    fetchHolidayTypes();
  }, [fetchHolidayTypes]);

  return { dataReq, fetchHolidayTypes };
}

export default useCustomScheduleHolidayTypes;
